import template from "./pCountry.html";
import featureFlags from "theme/utils/featureFlags.js";
import moment from "moment";
import { countryProjectsStore } from './countryProjects.store';
import angular from "angular";
import * as configs from './configs.js';
import * as userConfigs from '../pUser/configs.js';
import { checkClientNames, isSameClient } from '../utils';
import { cloneDeep } from "lodash";

export function pCountryDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCountryController,
    controllerAs: 'pCountry',
    bindToController: true,
  };

  return directive;
}

const manuallyProjectsFlag = "ProjectsSetManually";
const erpProjectsFlag = "ProjectsFromErpSystem";


class pCountryController {
  constructor(Auth, Admin, $routeParams, $location, $q, bModal, $translate, $scope, $interval, Notes, DownloadFile) {
    'ngInject';
    this.Auth = Auth;
    this.Admin = Admin;
    this.$routeParams = $routeParams;
    this.$location = $location;
    this.$q = $q;
    this.bModal = bModal;
    this.$translate = $translate;
    this.$scope = $scope;
    this.$interval = $interval;
    this.Notes = Notes;
    this.DownloadFile = DownloadFile;

    this.showModal = false;

    this.init();

    this.arrayOfFlags = featureFlags;

    this.projectsStore = countryProjectsStore;
    this.projectsStore.Admin = Admin;
    this.projectsStore.Notes = Notes;

    this.dataOrder = ['country', 'mdpInfo', 'mdpId', 'name', 'additionalInfo', 'taxId', 'clientGroupId', 'defaultBillingTypeId', 'multiselectKeywords'];

    this.sideBarConfig = {};

    this.tooltip = {
      featureFlags: {
        infoTitle: this.$translate.instant("TOOLTIP.COUNTRY_FEATURE_FLAG_TOOLTIP")
      },
      clients: {
        clientGroupName: {
          info: this.$translate.instant("TOOLTIP.COUNTRY_CLIENT_GROUP_NAME_TOOLTIP")
        },
        delete: {
          info: this.$translate.instant("TOOLTIP.COUNTRY_CLIENT_ACTION_TOOLTIP")
        }
      },
      processGoupsConfig: {
        name: {
          info: this.$translate.instant("TOOLTIP.LOCAL_NAME_TOOLTIP")
        },
        description: {
          info: this.$translate.instant("TOOLTIP.LOCAL_DESCRIPTION_TOOLTIP")
        }
      }
    };

    // Values
    this.valuesFields = configs.valuesFields;

    this.valuesActions = [];

    this.projectsFlagsArray = [
      { id: manuallyProjectsFlag, name: this.$translate.instant("COUNTRY.PROJECTS_SET_MANUALLY") },
      { id: erpProjectsFlag, name: this.$translate.instant("COUNTRY.PROJECTS_FROM_ERP_SYSTEM") },
      { id: "None", name: this.$translate.instant("COUNTRY.PROJECTS_NONE") }
    ];

    // Feature Flags
    this.featureFields = configs.featureFields;

    this.featuresActions = [];

    // Sites
    this.siteFields = configs.siteFields;

    this.siteActions = [];

    // this.siteRowActions = [];

    // Legal rules
    this.legalRulesFields = configs.legalRulesFields;

    this.legalRulesActions = configs.legalRulesActions;

    this.legalRulesRowActions = configs.legalRulesRowActions;

    // Teams
    this.teamFields = configs.teamFields;

    this.teamActions = configs.teamActions;

    this.teamRowActions = configs.teamRowActions;

    //User subs and alerts

    this.userSubsAndAlertsFields = {
      userName: "info",
      userTeamName: "info",
      role: "info",
      overtimeSubscription: "checkbox",
      profitabilitySubscription: "checkbox",
      worktimeSubscription: "checkbox",
      overtimeApplicationSubscription: "checkbox",
    };

    this.userSubsAndAlertsRowActions = [
      {
        name: "view",
        functionName: "viewUser"
      },
      {
        name: "add",
        functionName: "addNewSubOrAlert",
        fa: "fa-plus"
      }
    ];

    this.waitingClientsFields = configs.waitingClientsFields;

    this.waitingClientsRowActions = configs.waitingClientsRowActions;

    this.waitingClientsGlobalActions = configs.waitingClientsGlobalActions;

    // Clients
    this.isClientChecked = false;
    this.warnings = {};
    this.canSetProjectsManually = false;
    this.canSeeProjectsFromErp = false;

    this.clientFields = configs.clientFields;

    this.clientWithProjectsFields = configs.clientWithProjectsFields;

    this.clientActions = configs.clientActions;

    this.clientRowActions = configs.clientRowActions;

    this.clientWithProjectsRowActions = configs.clientWithProjectsRowActions;

    // Process Groups Configurations
    this.fields = configs.fields;

    this.actions = [];

    this.rowActions = configs.rowActions;

    // Interrupt Configurations
    this.interruptFields = configs.interruptFields;

    this.interruptActions = configs.interruptActions;

    this.interruptRowActions = configs.interruptRowActions;

    // Data for bDialogCard
    // Values
    this.editCountryValues = {};

    this.editCountryData = configs.editCountryData;

    // Holidays
    this.newHolidayData = configs.newHolidayData;

    // Feature Flags
    this.editFeatureValues = {};

    this.editFeatureData = {};
    this.arrayOfFlags.forEach(flag => {
      switch (flag) {
        case'PartTimeVacation':
          this.editFeatureData[flag] = {
            type: "checkbox_reliant",
            reliantOn: "VacationReporting",
            isNotRequired: true
          };
          break;
        case 'ClientMdpIdRequired':
          this.editFeatureData[flag] = {
            type: "checkbox_reliant",
            reliantOn: "ClientMdpIdAvailable",
            isNotRequired: true
          };
          break;
        default:
          this.editFeatureData[flag] = {
            type: "checkbox",
            isNotRequired: true
          };
      }
    });

    // Sites
    this.newSiteData = configs.newSiteData;

    //Legal Rules
    this.newLegalRuleData = configs.newLegalRuleData;

    this.defaultLegalRuleValues = configs.defaultLegalRuleValues;

    this.positionDialogCardWeekTable = configs.positionDialogCardWeekTable;

    this.dialogCardWidth = "wider";

    // Teams
    this.newwTeamData = configs.newwTeamData;

    // Clients
    // this.newClientData = configs.newClientData;

    this.clientSelect = configs.clientSelect;
    this.originClientSelect = configs.originClientSelect;
    this.originClientToEditData = configs.originClientToEditData;

    // Process Groups Configurations
    this.newConfigurationData = configs.newConfigurationData;

    this.configurationSelect = configs.configurationSelect;

    this.editConfigurationData = configs.editConfigurationData;

    this.deleteConfigurationData = configs.deleteConfigurationData;

    this.deleteConfigurationSelect = {};

    // Interrupt Configurations
    this.newInterruptData = configs.newInterruptData;

    this.interruptSelect = configs.interruptSelect;

    this.editInterruptData = configs.editInterruptData;

    this.deleteInterruptData = configs.deleteInterruptData;

    this.deleteInterruptSelect = {};

    this.newProblemValues = {
      "processGroupCountryConfigurationId": this.$routeParams.processId
    };

    this.newProblemData = configs.newProblemData;

    this.problemFields = configs.problemFields;

    this.problemActions = configs.problemActions;

    this.problemRowActions = configs.problemRowActions;

    this.daysDictionary = configs.daysDictionary;

    this.overtimeSubscriptionData = userConfigs.overtimeSubscriptionData;
    this.profitabilitySubscriptionData  = {
      ...userConfigs.profitabilitySubscriptionData,
      currency: {
        type: "radioSection",
        isNotRequired: true,
        options: [
          {
            name: "local",
            label: this.$translate.instant("SUBSCRIPTIONS.LOCAL"),
            value: "Local"
          },
          {
            name: "eur",
            label: "EUR",
            value: "EUR"
          }
        ]
      },
      longTermReportTwelveMonths: {
        type: "radioSection",
        isNotRequired: true,
        options: [
          {
            name: "sixMonths",
            label: this.$translate.instant("SUBSCRIPTIONS.SIX_MONTHS"),
            value: false
          },
          {
            name: "twelveMonths",
            label: this.$translate.instant("SUBSCRIPTIONS.TWELVE_MONTHS"),
            value: true
          }
        ]
      }
    };
    this.overtimeSubscriptionOrder = {
      AcceptedOvertime: 'Accepted overtime',
      AcceptedOvertimePercentage: 'Accepted overtime %',
      AcceptedWorklogPercentage: 'Accepted worklog %',
      CumulatedOvertime: 'Overtime balance',
      ReportedOvertime: 'Reported overtime'
    };
    this.subscriptionSelect = {
      sendAtMonthDay: Array.from({length: 31}, (_, i) => i + 1),
      orderBy: {
        valueToAdd: "id",
        valueToShow: "name",
        values: Object.keys(this.overtimeSubscriptionOrder).map(key => ({id: key, name: this.overtimeSubscriptionOrder[key]})),
      },
      teamRows: Array.from({length: 20}, (_, i) => (i + 1) * 5),
      employeeRows: Array.from({length: 10}, (_, i) => (i + 1) * 10)
    };
    this.teamColumnsWithThreshold = ['teamAcceptedOvertimeThreshold', 'teamReportedOvertimeThreshold', 'teamCumulatedOvertimeThreshold'];
    this.employeeColumnsWithThreshold = ['employeeAcceptedOvertimeThreshold', 'employeeReportedOvertimeThreshold', 'employeeCumulatedOvertimeThreshold'];

    this.automationDashboardFields = configs.automationDashboardFields;
    this.automationDashboardActions = configs.automationDashboardActions;
    this.automationDashboardRowActions = configs.automationDashboardRowActions;
    this.newTechnologyData = configs.newTechnologyData;
    this.historicExportData = configs.historicExportData;
    this.billingTypeData = [];

    $scope.$watchGroup([() => this.canSetProjectsManually, () => this.canSeeProjectsFromErp, () => this.mdpAvailableFlag], () => {
      if ([typeof this.canSeeProjectsFromErp, typeof this.canSeeProjectsFromErp,  typeof this.mdpAvailableFlag].includes('boolean')) {
        const fieldsPerErpFlag = angular.copy(this.canSetProjectsManually || this.canSeeProjectsFromErp ? this.clientWithProjectsFields : this.clientFields);
        this.clientsTableFields = this.mdpAvailableFlag
          ? fieldsPerErpFlag
          : Object
            .entries(fieldsPerErpFlag)
            .filter(([key]) => !['mdpId', 'mdpName'].includes(key))
            .reduce((accu, [key, value]) => ({...accu, [key]: value}) , {});
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;

        if (!this.user.isAdmin) {
          if (!this.user.isLocalAdmin)
            this.Auth.handleUnauthorized();
        }
        let promises = [
          this.Admin.getCountry(this.$routeParams.name),
          this.Admin.getServiceLines(),
          this.Admin.getClientGroups(),
          this.Admin.getGroups(),
          this.Admin.getWorktimeConfig(this.$routeParams.name),
          this.Admin.getAddressees(this.$routeParams.name),
          this.Admin.getSubsForCountry(this.$routeParams.name),
          this.Admin.getDuplicatedClients(this.$routeParams.name),
          this.Admin.getCountryBillingTypes(this.$routeParams.name)
        ];
        if (this.user.isAdmin)
          promises.push(this.Admin.getInterrupts());

        this.$q.all(promises).then(
          (success) => {
            function compare(a, b) {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }

              return 0;
            }
            this.country = success[0].data;
            this.serviceLines = promises[1] ? success[1].data : [];
            this.clientGroups = promises[2] ? success[2].data : [];
            this.groups = promises[3] ? success[3].data : [];

            this.legalRules = !success[4].data ? [] : success[4].data.legalWorktimeConfigs.map(config => {
              Object.entries(this.daysDictionary).forEach(([key, value]) => {
                config[value] = moment.duration(config.weekdaysThresholds[key]).asHours();
              });
              config.holidayThreshold = moment.duration(config.holidayThreshold).asHours();

              delete config.weekdaysThresholds;

              return config;
            });

            this.addressees = success[5].data
              ? success[5].data.addressees.filter(addressee => this.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e'
                ? addressee.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e'
                : true
              )
              : [];
            this.legalRulesSelect = {
              subscriptionUsers: {
                values: this.addressees,
                settings: {
                  displayProp: 'fullName',
                  showCheckAll: false,
                  showUncheckAll: false,
                  smartButtonMaxItems: 2,
                  checkBoxes: true,
                  scrollableHeight: '250px',
                  scrollable: true,
                  enableSearch: true,
                  closeOnBlur: true
                }
              }
            };

            this.userSubsAndAlertsSort = {
              userName: "userName",
              userTeamName: "userTeamName",
              role: "role",
              overtimeSubscription: "overtimeSubscription",
              profitabilitySubscription: "profitabilitySubscription",
              worktimeSubscription: "worktimeSubscription",
              overtimeApplicationSubscription: "overtimeApplicationSubscription"
            };

            this.userSubsAndAlerts = success[6].data ? success[6].data.map(info => ({
              ...info,
              userName: info.user.fullName,
              role: info.user.role.split(/(?=[A-Z])/).join(' ')
            })).sort((a, b) => a.userName.localeCompare(b.userName)) : [];

            this.defaultWaitingClients = promises[7]
              ? success[7].data.clients
                .filter(client => client.status !== 'Accepted')
                .map(client => {
                  const mutatedClient = {
                    ...client,
                    clientStatus: client.status,
                    fromMdp: Boolean(client.mdpId),
                    potentialDuplicatesTooltip: client.potentialDuplicates.map(duplicate => duplicate.name).join(", "),
                    potentialDuplicates: client.potentialDuplicates[0].name + `${client.potentialDuplicates.length > 1 ? ', ...' : ''}` || '',
                    potentialDuplicatesList: client.potentialDuplicates
                  };
                  delete mutatedClient.status;
                  return mutatedClient;
                })
              : [];
            this.waitingClients = this.declinedClientsVisible ? angular.copy(this.defaultWaitingClients) : this.defaultWaitingClients.filter(client => client.clientStatus !== 'Declined');

            this.billingTypeData = promises[8] && success[8].data.billingTypes
              ? Object.entries(success[8].data.billingTypes).reduce((accu, curr) => {
                const [id, name] = curr;
                accu.push({id, name, billingType: name, country: this.$routeParams.name});
                return accu;
              }, []).sort((billingTypeA, billingTypeB) => billingTypeA.name.localeCompare(billingTypeB.name))
              : [];

            this.interrupts = promises[9] ? success[9].data : [];
            this.projectsFlag = this.country.country.flags && this.country.country.flags.find(flag => flag === manuallyProjectsFlag || flag === erpProjectsFlag);
            this.overtimeApplicationsFlag = this.country.country.flags && this.country.country.flags.find(flag => flag === "OvertimeApplications");
            this.mdpAvailableFlag = this.country.country.flags && this.country.country.flags.some(flag => flag === "ClientMdpIdAvailable");
            this.mdpRequiredFlag = this.country.country.flags && this.country.country.flags.some(flag => flag === 'ClientMdpIdRequired');

            // Values
            this.countryData = [
              {
                countryLabel: this.$translate.instant("COUNTRY.COUNTRY_NAME"),
                countryValue: this.country.country.name
              },
              {
                countryLabel: this.$translate.instant("COUNTRY.CODE"),
                countryValue: this.country.country.code
              },
              {
                countryLabel: this.$translate.instant("COUNTRY.CURRENCY_CODE"),
                countryValue: this.country.country.currency
              },
              {
                countryLabel: this.$translate.instant("COUNTRY.PROJECTS_FLAG"),
                countryValue: this.projectsFlag ? this.$translate.instant("COUNTRY." + `${this.underscoreString(this.projectsFlag)}`) : this.$translate.instant("COUNTRY.PROJECTS_NONE")
              }
            ];

            this.projectsSelect = {
              projects_flag: {
                valueToAdd: "id",
                valueToShow: "name",
                values: this.projectsFlagsArray
              }
            };

            if (this.user.isAdmin) {
              this.valuesActions = [
                {
                  name: "edit",
                  functionName: "startEditingCountry",
                  fa: "fa-pencil-alt"
                }
              ];
            }


            // Feature flags
            this.featureFlags = [];

            if (this.user.isAdmin) {
              this.featuresActions = [
                {
                  name: "edit",
                  functionName: "startEditingFeatures",
                  fa: "fa-pencil-alt"
                }
              ];
            }

            this.arrayOfFlags.forEach(flag => {
              if (flag === "Projects") {
                const projectsFlag = this.country.country.flags && !!this.country.country.flags.find(flag => flag === manuallyProjectsFlag || flag === erpProjectsFlag);

                this.featureFlags.push({
                  feature: this.$translate.instant("COUNTRY." + `${this.underscoreString(flag)}`),
                  visible: projectsFlag
                });
              } else if (flag === "OvertimeRequest") {
                const overtimeApplicationsFlag = this.country.country.flags && this.country.country.flags.some(flag => flag === "OvertimeApplications");

                this.featureFlags.push({
                  feature: this.$translate.instant("COUNTRY." + `${this.underscoreString(flag)}`),
                  visible: overtimeApplicationsFlag
                });
              } else {
                let doesFlagExist = this.country.country.flags && !!this.country.country.flags.find(countryFlag => countryFlag == flag);

                this.featureFlags.push({
                  feature: this.$translate.instant("COUNTRY." + `${this.underscoreString(flag)}`),
                  visible: doesFlagExist
                });
              }
            });

            if (this.country.country.flags.some((flag) => flag === 'InteractiveNotes'))
              this.Admin.getAutomationTechnologyForCountry(this.country.country.name).then(
                (automationSuccess) => {
                  this.automationDashboardValues = automationSuccess && automationSuccess.data
                    ? Object
                      .entries(automationSuccess.data.automations)
                      .map(([id, automationName]) => ({id, automationName}))
                      .sort((technologyA, technologyB) => technologyA.automationName.localeCompare(technologyB.automationName))
                    : [];
                },
                () => {
                  if (this.automationDashboardValues)
                    this.automationDashboardValues = null;
                }
              );

            this.canSetProjectsManually = !!this.country.country.flags.find(f => f === manuallyProjectsFlag);
            this.canSeeProjectsFromErp = !!this.country.country.flags.find(f => f === erpProjectsFlag);

            // request - edit country
            this.editFeatureValues.country_name = this.country.country.name;
            this.editFeatureValues.currency_code = this.country.country.currency;

            // Sites
            this.sites = this.country.sites.sort(compare);

            if (this.user.isLocalAdmin) {
              this.sites = this.country.sites.filter(site => site.name != "Iterators HQ").sort(compare);
            }
            if (this.user.isAdmin) {
              this.siteActions = [
                {
                  name: "new",
                  functionName: "startAddingSite",
                  fa: "fa-plus"
                }
              ];

              this.siteRowActions = [
                {
                  name: "edit",
                  functionName: "startEditingSite",
                  fa: "fa-pencil-alt"
                },
                {
                  name: "delete",
                  functionName: "startDeletingSite",
                  fa: "fa-trash"
                }
              ];
            }

            this.problems = this.country.problems.sort(compare);

            // Holiday Calendar
            this.Admin.getHolidays(this.country.country.name).then(
              (success) => {
                if (this.user.isLocalAdmin) {
                  this.holidays = success.data.filter(s => s.siteId !== "de799481-a0f9-4c22-b91e-5f088a313586");
                }
                if (this.user.isAdmin) {
                  this.holidays = success.data;
                }
                this.holidays = this.holidays.map(h => {
                  let site = this.sites.find(s => s.id == h.siteId);
                  return { date: h.date, siteId: h.siteId, siteName: site.name };
                }).sort((a, b) => {
                  if (a.siteName < b.siteName) return -1;
                  if (a.siteName > b.siteName) return 1;
                  if (a.date < b.date) return -1;
                  if (a.date > b.date) return 1;
                  return 0;
                });

                this.holidayYear = moment().year();

                this.displayedHoliday = this.holidays && this.holidays.filter(h => h.date.substr(0, 4) == this.holidayYear);
              },
              (error) => {
                this.state = 'loaded';
                this.Notes.postNote({ type: "error", error: error });
              }
            );
            this.holidaySelect = {
              siteName: {
                valueToAdd: "id",
                valueToShow: "name",
                values: this.sites
              }
            };

            // Teams
            this.teams = this.country.teams.sort(compare).map(team => {
              team.archived = Boolean(team.archivedAt);
              delete team.archivedAt;
              return team;
            });

            if (this.user.isLocalAdmin) {
              this.teams = this.country.teams.filter(team => team.id !== "49a6dcff-c4e6-443e-9627-597070a68c8e").sort(compare);
            }

            localStorage.setItem("roedl-admin-teams", angular.toJson(this.teams));

            this.teamSelect = {
              "serviceLine": this.serviceLines
            };

            // Clients
            this.clients = this.country.clients.sort(compare).map(client => {
              return {
                ...client,
                hasProjects: client.projects.length > 0,
                mdpInfo: client.mdpId ? `${client.mdpName} (${client.mdpId})` : null
              };
            });

            this.clientSelect.clientGroupId.values = this.clientGroups.sort((a, b) => {
              if (a.name < b.name) return -1;
              if (a.name > b.name) return 1;
              return 0;
            });
            this.clientSelect.clientGroupId.values.unshift({ id: "0", name: " " });

            this.clientSelect.defaultBillingTypeId.values = new Array({id: '', name: ''}, ...cloneDeep(this.billingTypeData));

            if (this.user.isLocalAdmin) {
              this.clientRowActions.find(a => a.name === 'delete').class = "deleteGrayedOut";
            }

            //Process groups configurations
            this.groupCountryConfigurations = this.country.processGroupCountryConfigs.sort(compare);
            if (this.user.isAdmin) {
              this.actions = [
                {
                  name: "new",
                  functionName: "startAddingNewConfiguration",
                  fa: "fa-plus"
                }
              ];

              this.rowActions = [
                {
                  name: "edit",
                  functionName: "startEditingConfiguration",
                  fa: "fa-pencil-alt"
                },
                {
                  name: "processes",
                  functionName: "openProcesses"
                },
                {
                  name: "delete",
                  functionName: "startDeletingConfiguration",
                  fa: "fa-trash"
                }
              ];
            }

            var processGroupsHere = [].concat(this.groups);
            this.groupCountryConfigurations.map((gcc) => {
              processGroupsHere.filter((pg) => { return pg.id == gcc.processGroupId; }).map((pg) => {
                gcc.cannonicalName = pg.name;
              });
            });

            localStorage.setItem("roedl-admin-groupCountryConfigurations", angular.toJson(this.groupCountryConfigurations));

            this.configurationSelect.processGroupId.values = [].concat(this.groups);

            // Interrupt configurations
            this.interruptCountryConfiguration = this.country.interruptCountryConfigs && this.country.interruptCountryConfigs.sort(compare);
            this.interruptSelect.interruptId.values = [].concat(this.interrupts);

            this.sideBarConfig = {
              "country": this.$routeParams.name,
              "groupCountryConfigurations": this.groupCountryConfigurations,
              "teams": this.teams.filter(team => !team.archived)
            };

            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({ type: "error", error: error });
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => { this.$interval.cancel(timeout); });
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  moveHolidayYear(type) {
    if (type == "+") {
      this.holidayYear = this.holidayYear + 1;
    }
    if (type == "-") {
      this.holidayYear = this.holidayYear - 1;
    }
    this.displayedHoliday = this.holidays && this.holidays.filter(h => h.date.substr(0, 4) == this.holidayYear);
  }

  startAddingNewHoliday() {
    this.newHolidayValues = null;
    this.newHolidayProcess = true;
  }

  addNewHoliday() {
    this.newHolidayProcess = false;
    this.state = "loading";

    this.Admin.addNewHoliday(this.newHolidayValues.siteName, this.newHolidayValues.date).then(
      () => {
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  deleteHoliday(holiday) {
    this.state = "loading";
    this.Admin.deleteHoliday(holiday.siteId, holiday.date).then(
      () => {
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  underscoreString(string) {
    return string.split(/(?=[A-Z])/).join("_").toUpperCase();
  }

  startEditingCountry() {
    this.editCountryValues.country_name = this.country.country.name;
    this.editCountryValues.code = this.country.country.code;
    this.editCountryValues.currency_code = this.country.country.currency;
    this.editCountryValues.projects_flag = this.country.country.flags.find(flag => flag === manuallyProjectsFlag || flag === erpProjectsFlag);

    this.editCountryProcess = true;
  }

  startEditingFeatures() {
    this.arrayOfFlags.forEach(flag => {
      if (flag === "Projects") {
        const projectsFlag = this.country.country.flags && !!this.country.country.flags.find(flag => flag === manuallyProjectsFlag || flag === erpProjectsFlag);
        this.editFeatureValues[flag] = projectsFlag;
      } else if (flag === "OvertimeRequest") {
        const overtimeApplicationsFlag = this.country.country.flags && this.country.country.flags.some(flag => flag === "OvertimeApplications");
        this.editFeatureValues[flag] = overtimeApplicationsFlag;
      } else {
        let doesFlagExist = this.country.country.flags && !!this.country.country.flags.find(countryFlag => countryFlag == flag);
        this.editFeatureValues[flag] = doesFlagExist;
      }
    });
    this.editFeatureProcess = true;
  }

  updateCountry(country) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';
    let flags = this.country.country.flags || [];
    const projectFlagThatExists = flags.find(flag => flag === manuallyProjectsFlag || flag === erpProjectsFlag);
    const projectFlagExists = !!projectFlagThatExists;
    const doesSameProjectsFlagExist = flags && projectFlagExists && (country.projects_flag === projectFlagThatExists);
    if (country.projects_flag && !doesSameProjectsFlagExist) {
      flags = flags.filter((x) => x != this.projectsFlag);
      if (country.projects_flag !== "None") {
        flags = [
          ...flags,
          country.projects_flag
        ];
      }
    }

    var updatedCountry = {
      "currency": country.currency_code,
      "flags": flags,
      code: country.code
    };

    this.Admin.updateCountry(country.country_name, updatedCountry).then(
      () => {
        this.editCountryProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  updateFeature(features) {
    if (this.state == 'loading')
      return;
    this.state = 'loading';

    let flags = [];

    this.arrayOfFlags.forEach(f => {
      if (features[f] == true && f === "Projects") {
        const flagToSend = this.projectsFlag || manuallyProjectsFlag;
        flags.push(flagToSend);
      } else if (f === "OvertimeRequest" && features[f] == true) {
        flags.push("OvertimeApplications");
      } else if (features[f] == true && f !== "Projects" && f !== "OvertimeRequest") {
        flags.push(f);
      }
    });

    let updatedCountry = {
      "currencyCode": this.editFeatureValues.currency_code,
      "flags": flags
    };

    this.Admin.updateCountry(this.$routeParams.name, updatedCountry).then(
      () => {
        this.editFeatureProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startAddingNewConfiguration() {
    this.newConfigurationValues = null;
    this.newConfigurationValues = {
      "country": this.$routeParams.name
    };
    this.newConfigurationProcess = true;
  }

  addConfiguration(configuration) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.addGroupCountryConfiguration(configuration).then(
      () => {
        this.newConfigurationProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startEditingConfiguration(configuration) {
    this.editConfigurationProcess = true;
    this.editConfigurationValues = angular.fromJson(angular.toJson(configuration));
    this.editConfigurationSelect = {
      processGroupId: this.configurationSelect.processGroupId.values.find(pg => pg.id == configuration.processGroupId).name
    };
  }

  updateConfiguration(configuration) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.updateGroupCountryConfiguration(configuration.id, configuration).then(
      () => {
        this.editConfigurationProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startDeletingConfiguration(configuration) {
    this.deleteConfigurationProcess = true;
    this.deleteConfigurationValues = configuration;
    this.deleteConfigurationSelect.processGroupId = this.configurationSelect.processGroupId.values.find(pg => pg.id == this.deleteConfigurationValues.processGroupId).name;
  }

  deleteConfiguration(configuration) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteGroupCountryConfiguration(configuration.id).then(
      () => {
        this.deleteConfigurationProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  openProcesses(configuration) {
    this.$location.path('/admin/countries/' + this.$routeParams.name + '/process_group_configurations/' + configuration.id);
  }

  openTeam(team) {
    this.$location.path('/admin/countries/' + this.$routeParams.name + '/team/' + team.id);
  }

  startAddingNewInterrupt() {
    this.newInterruptValues = null;
    this.newInterruptValues = {
      "country": this.$routeParams.name,
      "includeInReports": true,
      "hasValueAdded": false
    };
    this.newInterruptConfiguration = true;
  }

  addNewInterruptConfiguration(interrupt) {
    if (!interrupt.hasServiceLine) {
      interrupt.hasServiceLine = false;
    }
    if (!interrupt.includeInReports) {
      interrupt.includeInReports = false;
    }
    if (!interrupt.hasClient) {
      interrupt.hasClient = false;
    }

    this.modalConfig = {
      text: "COUNTRY.INTERRUPTS.ADD_CONFIRMATION",
      cancelText: "CANCEL",
      acceptText: "SUBMIT"
    };

    this.bModal.show(this.modalConfig).then(
      () => {
        this.Admin.addInterruptCountryConfiguration(interrupt).then(
          () => {
            this.newInterruptConfiguration = false;
            this.init();
          },
          (error) => {
            this.Notes.postNote({ type: "error", error: error });
          }
        );
      },
      () => {
        // CANCEL action
      }
    );
  }

  startEditingInterrupt(interrupt) {
    this.editInterruptConfiguration = true;
    this.editInterruptValues = angular.fromJson(angular.toJson(interrupt));
    this.editInterruptSelect = {
      interruptId: this.interruptSelect.interruptId.values.find(i => i.id == this.editInterruptValues.interruptId).name
    };
  }

  updateInterruptConfiguration(configuration) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.updateInterruptCountryConfiguration(configuration.id, configuration).then(
      () => {
        this.editInterruptConfiguration = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startDeletingInterrupt(interrupt) {
    this.deleteInterruptConfiguration = true;
    this.deleteInterruptValues = interrupt;
    this.editInterruptSelect = {
      interruptId: this.interruptSelect.interruptId.values.find(i => i.id == this.deleteInterruptValues.interruptId).name
    };
  }

  deleteInterrupt(interrupt) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteInterruptCountryConfiguration(interrupt.id).then(
      () => {
        this.deleteInterruptConfiguration = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startAddingNewClient() {
    this.newClientData = angular.copy(configs.newClientData);
    this.isClientChecked = false;
    this.warnings = {};

    if (!this.user.isAdmin && !this.user.isLocalAdmin) {
      delete this.newClientData.additionalInfo;
    }

    this.newClientValues = null;
    this.newClientValues = {
      "country": this.$routeParams.name,
      "clientGroupId": "0",
      multiselectKeywords: []
    };

    if (this.mdpAvailableFlag) {
      this.newNameFromMdp = null;
      this.newClientData.mdpInfo = {
        type: "textWithSearch",
        searchFn: (value) => this.searchMdpId(value),
        setClientFromMdp: (client) => this.setClientFromMdp(client),
        options: [],
        isNotRequired: !this.mdpRequiredFlag
      };

      this.newClientData.mdpId = {
        type: "text",
        disabledFn: () => true
      };

      this.newClientData.name = {
        ...this.newClientData.name,
        buttonHandlerDisabled: true,
        buttonHandlerLabel: 'Override',
        buttonHandler: () => this.overrideClientName()
      };

      this.newClientData = this.dataOrder.reduce((accu, curr) => {
        accu[curr] = this.newClientData[curr];

        if (this.mdpRequiredFlag && curr !== 'mdpInfo' && curr !== 'mdpId')
          accu[curr].disabledFn = () => !this.newClientValues.mdpId;

        if (!accu[curr])
          delete accu[curr];

        return accu;
      }, {});
    }

    if (this.billingTypeData.length === 0)
      delete this.newClientData.defaultBillingTypeId;

    this.newClientProcess = true;
    this.newClientMdpIdChanged = false;
  }

  checkAndAddClient(client) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    const similarClientNames = checkClientNames(this.clients, client);
    const sameTaxes = this.clients.filter(c => c.taxId.toLowerCase() == client.taxId.toLowerCase())
      .filter(c => c.taxId.toLowerCase() != 'missing')
      .map(c => c.name);

    const firstCheck = !this.isClientChecked;
    const anySimilarClientNames = similarClientNames.length > 0;
    const anySameTax = sameTaxes.length > 0;
    const anySameName = isSameClient(this.clients, 'name', client);

    const setWarnings = () => {
      this.warnings = {
        sameTax: isSameClient(this.clients, 'taxId', client) && sameTaxes[0],
        sameName: isSameClient(this.clients, 'name', client) && similarClientNames.find(d => d.toLowerCase() == client.name.toLowerCase()),
        similarNames: similarClientNames.length > 0 && similarClientNames,
        blocked: isSameClient(this.clients, 'taxId', client) || isSameClient(this.clients, 'name', client),
        any: similarClientNames.length > 0 || sameTaxes.length > 0
      };
    };

    if (firstCheck) {
      if (anySimilarClientNames || anySameTax) {
        setWarnings();
        this.state = 'loaded';
      } else {
        this.addClient(client);
      }
    } else {
      if (anySameTax || anySameName) {
        setWarnings();
        this.state = 'loaded';
      } else {
        this.addClient(client);
      }
    }

    this.isClientChecked = true;
  }

  addClient(client) {
    this.state = 'loading';

    if (client.clientGroupId == "0") {
      delete client.clientGroupId;
    }

    if (client.defaultBillingTypeId === "") {
      delete client.defaultBillingTypeId;
    }

    delete client.multiselectKeywordsValue;

    this.Admin.addClient(client).then(
      () => {
        this.newClientProcess = false;
        this.warnings = {};
        this.isClientChecked = true;

        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  viewProjects(client) {
    this.state = 'loading';

    const selectedClientProjects = this.selectedClient && this.selectedClient.hasProjects;

    if (this.canSeeProjectsFromErp) {
      this.selectedClient = client;
      this.projectsStore.makeSyncERPprojects(client.id).then(
        () => {
          this.projectsStore.getProjects(client.id).then(() => {
            this.showModal = true;
            this.state = 'loaded';
          }).catch((error) => {
            this.Notes.postNote({ type: "error", error: error });
          });

          if (!selectedClientProjects) {
            this.init();
            this.selectedClient.hasProjects = this.projectsStore.hasProjects;
          }

        },
        () => {
          this.projectsStore.clearAllProjects();
          this.state = 'loaded';
          this.showModal = true;
        },
      );
    } else {
      this.projectsStore.getProjects(client.id).then(() => {

        this.state = 'loaded';
        this.showModal = true;
      }).catch((error) => {
        this.Notes.postNote({ type: "error", error: error });
      });
      this.selectedClient = client;
    }
  }

  startEditingClient(client) {
    this.newClientData = angular.copy(configs.newClientData);
    this.editClientProcess = true;
    this.editClientValues = angular.fromJson(angular.toJson(client));

    if (!this.user.isAdmin && !this.user.isLocalAdmin) {
      delete this.newClientData.additionalInfo;
    }

    if (!this.editClientValues.multiselectKeywords)
      this.editClientValues.multiselectKeywords = [];

    if (this.billingTypeData.length === 0)
      delete this.newClientData.defaultBillingTypeId;

    if (this.mdpAvailableFlag) {

      this.newNameFromMdp = null;

      this.newClientData.mdpInfo = {
        type: "textWithSearch",
        searchFn: (value) => this.searchMdpId(value),
        setClientFromMdp: (client) => this.setClientFromMdp(client),
        options: [],
        disabled: !this.mdpAvailableFlag
      };

      this.newClientData.mdpId = {
        type: "text",
        editionDisabled: true
      };

      this.newClientData.name = {
        ...this.newClientData.name,
        buttonHandlerDisabled: true,
        buttonHandlerLabel: 'Override',
        buttonHandler: () => this.overrideClientName()
      };

      if (this.mdpRequiredFlag)
        this.newClientData.mdpInfo.isNotRequired = false;

      this.newClientData = this.dataOrder.reduce((accu, curr) => {
        accu[curr] = this.newClientData[curr];

        if (this.mdpRequiredFlag && curr !== 'mdpInfo')
          accu[curr].disabledFn = () => !this.editClientValues.mdpId;

        return accu;
      }, {});
    }

    if (!client.clientGroupId) {
      this.editClientValues.clientGroupId = "0";
    }
  }

  closeModal() {
    this.showModal = false;
  }

  updateClient(client) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    if (client.clientGroupId == "0") {
      delete client.clientGroupId;
    }

    if (client.defaultBillingTypeId === "") {
      delete client.defaultBillingTypeId;
    }

    delete client.multiselectKeywordsValue;

    this.Admin.updateClient(client.id, client).then(
      () => {
        this.editClientProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startDeletingClient(client) {
    this.newClientData = angular.copy(configs.newClientData);
    this.deleteClientValues = angular.fromJson(angular.toJson(client));
    this.deleteClientSelect = {
      clientGroupId: this.deleteClientValues.clientGroupName,
      defaultBillingTypeId: this.deleteClientValues.defaultBillingTypeName
    };
    this.deleteClientProcess = true;
  }

  deleteClient(client) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteClient(client.id).then(
      () => {
        this.deleteClientProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startAddingSite() {
    this.newSiteProcess = true;
    this.newSiteValues = null;
    this.newSiteValues = {
      "country": this.$routeParams.name
    };
  }

  addSite(site) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.addSite(site).then(
      () => {
        this.newSiteProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startEditingSite(site) {
    this.editSiteProcess = true;
    this.editSiteValues = angular.fromJson(angular.toJson(site));
  }

  updateSite(site) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.updateSite(site.id, site).then(
      () => {
        this.editSiteProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startDeletingSite(site) {
    this.deleteSiteProcess = true;
    this.deleteSiteValues = angular.fromJson(angular.toJson(site));
  }

  deleteSite(site) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteSite(site.id).then(
      () => {
        this.deleteSiteProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startAddingTeam() {
    this.newTeamProcess = true;
    this.newTeamValues = null;
    this.newTeamValues = {
      "country": this.$routeParams.name,
      "excludeFromProfitabilityReport": false
    };
  }

  addTeam(team) {
    this.Admin.addTeam(team).then(
      () => {
        this.newTeamProcess = false;
        this.init();
      },
      (error) => {
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startEditingTeam(team) {
    this.editTeamProcess = true;
    this.editTeamValues = angular.fromJson(angular.toJson(team));
  }

  updateTeam(team) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.updateTeam(team.id, team).then(
      () => {
        this.editTeamProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startDeletingTeam(team) {
    this.deleteTeamProcesss = true;
    this.deleteTeamValues = angular.fromJson(angular.toJson(team));
  }

  deleteTeam(team) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteTeam(team.id).then(
      () => {
        this.deleteTeamProcesss = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({ type: "error", error: error });
      }
    );
  }

  startAdddingProblem() {
    this.newProblemValues = null;
    this.newProblemProcess = true;
  }

  addProblem(problem) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    problem.processGroupCountryConfigurationId = this.$routeParams.processId;
    this.Admin.addProblem({...problem, country: this.country.country.name}).then(
      () => {
        this.newProblemProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingProblem(problem) {
    this.editProblemProcess = true;
    this.editProblemValues = angular.fromJson(angular.toJson(problem));
  }

  updateProblem(problem) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.updateProblem(problem.id, problem).then(
      () => {
        this.editProblemProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startDeletingProblem(problem) {
    this.deleteProblemProcess = true;
    this.deleteProblemValues = angular.fromJson(angular.toJson(problem));
  }

  deleteProblem(problem) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteProblem(problem.id).then(
      () => {
        this.deleteProblemProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  viewUser(userInfo) {
    this.$location.path('/admin/countries/' + this.$routeParams.name + '/team/' + userInfo.user.teamId + '/user/' + userInfo.user.id);
  }

  startAddingLegalConfiguration() {
    this.newLegalRules = true;
    this.newLegalRuleValues = angular.copy(this.defaultLegalRuleValues);
    this.newLegalRuleValues.subscriptionUsers = this.addressees.filter(addressee => addressee.hasLegalWorktimeSubscription);
  }

  addLegalRule(values) {
    const valuesToSend = angular.copy(values);
    const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

    const data = {
      ...valuesToSend,
      weekdaysThresholds: days.map(day => moment.duration(valuesToSend[day], 'hour').toJSON()),
      holidayThreshold: moment.duration(valuesToSend.holidayThreshold, 'hour').toJSON(),
      country: this.country.country.name
    };

    const usersId = data.subscriptionUsers.map(user => user.userId);
    delete data.subscriptionUsers;

    days.forEach(day => delete data[day]);

    this.state = 'loading';

    this.$q.all([this.Admin.createWorktimeConfig(data), this.Admin.setAddressees(this.country.country.name, {usersId})]).then(
      () => {
        this.newLegalRules = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  legalRulesFormInvalid(values) {
    if (this.state == 'loading')
      return;

    const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

    return (
      !values.validFrom
      || moment(values.validFrom).isBefore(moment().subtract(1, 'day'), 'day')
      || days.some(day => values[day] < 0 || typeof values[day] !== 'number' || values[day] % 1 !== 0)
      || values.holidayThreshold < 0
      || typeof values.holidayThreshold !== 'number'
      || values.holidayThreshold % 1 !== 0
      || values.subscriptionUsers.length === 0
    );
  }

  startDeletingLegalRules(values) {
    this.deleteLegalRulesProcess = true;
    this.deleteLegalRulesValues = angular.copy(values);
  }

  deleteLegalRules(values) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteWorktimeConfig(values.id).then(
      () => {
        this.deleteLegalRulesProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingLegalRules(values) {
    this.editLegalRulesProcess = true;
    this.editLegalRuleValues = angular.copy(values);
    this.editLegalRuleValues.subscriptionUsers = this.addressees.filter(addressee => addressee.hasLegalWorktimeSubscription);
  }

  editLegalRule(values) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    const valuesToSend = angular.copy(values);
    const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

    const data = {
      ...valuesToSend,
      weekdaysThresholds: days.map(day => moment.duration(valuesToSend[day], 'hour').toJSON()),
      holidayThreshold: moment.duration(valuesToSend.holidayThreshold, 'hour').toJSON()
    };

    const usersId = data.subscriptionUsers.map(user => user.userId);
    delete data.subscriptionUsers;

    days.forEach(day => delete data[day]);

    this.$q.all([this.Admin.editWorktimeConfig(data), this.Admin.setAddressees(this.country.country.name, {usersId})]).then(
      () => {
        this.editLegalRulesProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  addNewSubOrAlert(values) {
    this.chooseSubscription = true;
    this.subUserInfo = values.user;
  }

  startAddingSubscription() {
    this.chooseSubscription = false;
    this.subscriptionValues = {
      language: 'en',
      currency: 'Local',
      longTermReportTwelveMonths: false
    };
    this.subscriptionType = 'profitability';
    this.subscriptionData = this.profitabilitySubscriptionData;
    this.addSubscriptionProcess = true;
  }

  startAddingOvertimeSubscription() {
    this.subscriptionSelect.orderBy = {
      valueToAdd: "id",
      valueToShow: "name",
      values: Object.keys(this.overtimeSubscriptionOrder).map(key => ({id: key, name: this.overtimeSubscriptionOrder[key]}))
    };
    this.chooseSubscription = false;
    this.subscriptionValues = {
      language: 'en',
      teamRows: "10",
      employeeRows: "10",
      orderBy: "CumulatedOvertime"
    };
    this.subscriptionType = 'overtime';
    this.subscriptionData = this.overtimeSubscriptionData;
    this.addSubscriptionProcess = true;
  }

  startAddingLegalRulesAlert() {
    this.chooseSubscription = false;
    this.addLegalRuleAlertModalLanguage = 'EN';
    this.addLegalRuleAlertModal = true;
  }

  formInvalid(values) {
    if (
      this.subscriptionType === 'profitability'
      && (values.profitability || values.hourlyRate || values.duration || values.overtime)
      && values.sendAtMonthDay
      && values.sendAtMonthDay.length > 0
    )
      return false;
    else if (
      this.subscriptionType === 'overtime'
      && values.sendAtMonthDay
      && values.sendAtMonthDay.length > 0
      && Object.keys(values).every(value => !value.includes('ThresholdError'))
      && (values.team || values.employee)
      && (!values.team || this.teamColumnsWithThreshold.some(key => values[key]))
      && (!values.employee || this.employeeColumnsWithThreshold.some(key => values[key]))
    )
      return false;
    else if (
      this.subscriptionType === 'overtimeRequestsAlert'
      && (
        (values.allTeams && !values.teamId) 
        || (!values.allTeams && values.teamId)
      )
    ) {
        return false;
      }
    else
      return true;
  }

  prepareSubscriptionData(values) {
    let data = {};
    const tables = [];

    Object.entries(values).forEach(([key, value]) => {
      if (value === true && key !== "longTermReportTwelveMonths" && key !== "overtimeSubscription" && key !== "profitabilitySubscription")
        tables.push(key.charAt(0).toUpperCase() + key.slice(1));
      else if (this.teamColumnsWithThreshold.includes(key) && value)
        data[key] = moment.duration(value);
      else if (this.employeeColumnsWithThreshold.includes(key) && value)
        data[key] = moment.duration(value);
      else if (key.includes('Rows') || key === 'sendAtMonthDay')
        data[key] = parseInt(value);
      else if (key === 'orderBy')
        data[key] = value.split(" ").join("");
      else
        data[key] = value;
    });

    data = {
      ...data,
      userId: this.subUserInfo.id,
      tables: tables
    };

    return data;
  }

  createSubscription(values) {
    const valuesForRequest = angular.copy(values);
    this.state = 'loading';

    if (this.subscriptionType === 'overtime') {
      if (!valuesForRequest.employee) {
        delete valuesForRequest.employeeRows;
        this.employeeColumnsWithThreshold.forEach(key => valuesForRequest[key] = null);
      }

      if (!valuesForRequest.team) {
        delete valuesForRequest.teamRows;
        this.teamColumnsWithThreshold.forEach(key => valuesForRequest[key] = null);
      }
    }

    const data = this.subscriptionType === 'overtimeRequestsAlert' ? {...valuesForRequest, userId: this.subUserInfo.id} : this.prepareSubscriptionData(valuesForRequest);
    let request;

    switch (this.subscriptionType) {
      case 'overtime':
        request = this.Admin.createUserOvertimeSubscription(data);
        break;
      case 'profitability':
        request = this.Admin.createUserProfitabilitySubscription(data);
        break;
      case 'overtimeRequestsAlert':
        if (data.allTeams === false) delete data.allTeams;
        request = this.Admin.createUserOvertimeRequestsSubscription(data);
        break;
      default:
        this.Notes.postNote({type: "error", error: "Unknown subscription type"});
        return;
    }

    request.then(
      () => {
        this.addSubscriptionProcess = false;
        this.editSubscriptionProcess = false;
        this.subUserInfo = null;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  addLegalRuleAlert() {
    this.state = 'loading';

    const data = {
      userId: this.subUserInfo.id,
      language: this.addLegalRuleAlertModalLanguage
    };

    this.Admin.createUserLegalRuleAlert(data).then(
      () => {
        this.state = 'loaded';
        this.addLegalRuleAlertModal = false;
        this.subUserInfo = null;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startAdddingTechnology() {
    this.newTechnologyValues = null;
    this.newTechnologyProcess = true;
  }

  addTechnology(technology) {
    if (this.state === 'loading')
      return;

    this.state = 'loading';

    this.Admin.createAutomationTechnology(this.country.country.name, technology).then(
      () => {
        this.newTechnologyProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingTechnology(technology) {
    this.editTechnologyProcess = true;
    this.editTechnologyValues = angular.fromJson(angular.toJson(technology));
  }

  updateTechnology(technology) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.updateAutomationTechnology(this.country.country.name, technology.id, technology.automationName).then(
      () => {
        this.editTechnologyProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startDeletingTechnology(technology) {
    this.deleteTechnologyProcess = true;
    this.deleteTechnologyValues = angular.fromJson(angular.toJson(technology));
  }

  deleteTechnology(technology) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteAutomationTechnology(this.country.country.name, technology.id).then(
      () => {
        this.deleteTechnologyProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  exportTechnology() {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    return this.Admin.exportAutomationDashboardData(this.country.country.name).then(
      (success) => {
        this.state = "loaded";
        this.DownloadFile.downloadFromResponse(
          success,
          success.headers("application/zip"),
          `Automation Technologies - ${this.country.country.name} - ${moment().format('YYYY-MM-DD')}.zip`
        );
      }, (error) => {
        this.error = error;
        this.state = 'error';
      }
    );
  }

  startHistoricExport() {
    this.historicExportProcess = true;
    this.historicExportValues = {};
  }

  historicExport(exportValues) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';
    const from = moment(exportValues.from).format('YYYY-MM');
    const to = moment(exportValues.to).format('YYYY-MM');

    return this.Admin.exportAutomationDashboardData(this.country.country.name, {from: from, to: to, changesOnly: this.historicExportChangeProcess}).then(
      (success) => {
        this.state = "loaded";
        this.DownloadFile.downloadFromResponse(
          success,
          this.historicExportChangeProcess ? 'content-type' : "application/zip",
          `Automation Technologies ${this.historicExportChangeProcess ? 'Changes ' : ''}- ${this.country.country.name} - ${from} - ${to}.${this.historicExportChangeProcess ? 'xlsx' : 'zip'}`
        );
        this.historicExportProcess = false;
        this.historicExportChangeProcess = false;
      }, (error) => {
        this.error = error;
        this.state = 'error';
      }
    );
  }

  historicExportFormInvalid(values) {
    return (
      this.state === 'loading'
      || !values
      || !values.from
      || !values.to
      || !moment(values.from).isValid()
      || !moment(values.from).isValid()
      || moment(values.from).isAfter(values.to)
      || moment(values.to).isSameOrAfter(moment())
    );
  }

  startHistoricExportChange() {
    this.historicExportChangeProcess = true;
    this.historicExportValues = {};
  }

  getMdpClients(name) {
    return this.Admin.getMdpClients(name)
      .then(
        (success) => {
          if (success.status === 204)
            return [];

          const clients = success.data.map(client => {
            return Object.entries(client).reduce((accu, [key, value]) => {
              accu[key] = value === 'brak' ? '' : value;
              return accu;
            }, {});
          });

          return clients.map(client => ({value: client.id, label: `${client.name} - ${client.country} ${client.streetAddress}, ${client.city} ${client.postalCode}`, ...client}));
        }, () => {
          return [];
        });
  }

  searchMdpId(value) {
    if (value.length < 3)
      return Promise.resolve([]);
    else
      return this.getMdpClients(value);
  }

  setClientFromMdp(client) {
    if (this.newClientProcess && !this.newClientMdpIdChanged) {
      delete this.newClientData.name.reliantOn;
      delete this.newClientData.taxId.reliantOn;
      this.newClientMdpIdChanged = true;
    }

    const valuesVariable = this.newClientProcess ? 'newClientValues': 'editClientValues';
    if (!client) {
      this[valuesVariable].mdpId = null;
      this[valuesVariable].mdpName = null;
    }
    else {
      this[valuesVariable].taxId = client.taxId && client.taxId.length > 0 ? client.taxId : 'MISSING';
      const newName = client.name && client.name.length > 0 ? client.name : '';
      
      if (!this[valuesVariable].name || this[valuesVariable].name.length === 0)
        this[valuesVariable].name = newName;
      else if (newName !== this[valuesVariable].name) {
        this.newClientData.name.buttonHandlerDisabled = false;
        this.newNameFromMdp = newName;
      }
      this[valuesVariable].mdpId = client.id;
      this[valuesVariable].mdpName = client.name;
    }
  }

  acceptWaitingClient(client) {
    this.acceptOrDeclineWaitingClient(client.id, 'Accepted');
  }

  declineWaitingClients(client) {
    this.acceptOrDeclineWaitingClient(client.id, 'Declined');
  }

  acceptOrDeclineWaitingClient(clientId, status) {
    this.state = 'loading';
    this.Admin.acceptOrDeclineWaitingClient(this.$routeParams.name, clientId, status).then(
      () => {
        this.state = 'loaded';
        this.init();
      }, (error) => {
        this.error = error;
        this.state = 'error';
      }
    );
  }

  toggleDeclinedClients() {
    this.declinedClientsVisible = !this.declinedClientsVisible;

    if (this.declinedClientsVisible) {
      this.waitingClientsGlobalActions[0].name = "hide_declined_clients";
      this.waitingClients = angular.copy(this.defaultWaitingClients);
    } else {
      this.waitingClients = this.defaultWaitingClients.filter(client => client.clientStatus !== 'Declined');
      this.waitingClientsGlobalActions[0].name = "show_declined_clients";
    }
  }

  validateClients(values) {
    return this.mdpRequiredFlag && !values.mdpId;
  }

  editOriginClient(client) {
    if (client.potentialDuplicatesList.length === 1) {
      const originClient = this.clients.find(originClient => originClient.id === client.potentialDuplicatesList[0].id);
      this.startEditingClient(originClient);
    } else {
      this.editOriginClientSelection = true;
      // this.originClientSelect = client.potentialDuplicatesList;
      this.originClientSelect.client.values = client.potentialDuplicatesList;
      this.originClientToEditValues = { client: client.potentialDuplicatesList[0].id };
    }
  }

  pickOriginClient({ client }) {
    this.editOriginClientSelection = false;
    this.originClientToEditValues = null;
    const originClient = this.clients.find(originClient => originClient.id === client);
    this.startEditingClient(originClient);
  }

  downloadClientNotes(client) {
    this.Admin.getClientNotes(client.id)
      .then((success) => {
        this.DownloadFile.downloadFromResponse(
          success,
          'application/zip',
          `${client.name.replace(/\./g, '').toLowerCase()} process documentation`
        );
      }, (err) => {
        const message = String.fromCharCode.apply(null, new Uint8Array(err.data));

        this.Notes.postNote({
          type: "error",
          error: message.includes("Found zero notes for client")
            ? "Client has no notes."
            : "Something wrong happened. Try again later."
        });
      });
  }

  overrideClientName() {
    const valuesVariable = this.newClientProcess ? 'newClientValues': 'editClientValues';
    this[valuesVariable].name = this.newNameFromMdp;
    this.newNameFromMdp = null;
    this.newClientData.name.buttonHandlerDisabled = true;
  }

  valuesFormInvalid(values) {
    const currencyPattern = /^[A-Z]{3}$/;
    const codePattern = /^[A-Z]{2}$/;
    
    if (!values) return true;

    if (
      values.code
      && codePattern.test(values.code)
      && values.currency_code
      && currencyPattern.test(values.currency_code)
    )
      return false;
    
    return true;
  }

  setState() {
    return (state) => {
      this.state = state;
    };
  }

  refreshHandler() {
    return () => this.init();
  }

  postNoteHandler() {
    return (note) => this.Notes.postNote(note);
  }

  doesBillingTypeIsDefault() {
    return (billingType) => {
      return this.clients.some(client => client.defaultBillingTypeId === billingType.id);
    };
  }

  exportTeams() {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    return this.Admin.exportTeamsInCountryData(this.country.country.name).then(
      (success) => {
        this.state = "loaded";
        this.DownloadFile.downloadFromResponse(
          success,
          success.headers('content-type'),
          `${this.country.country.name} - Teams - ${moment().format('YYYY-MM-DD')}.xlsx`
        );
      }, (error) => {
        this.error = error;
        this.state = 'error';
      }
    );
  }

  startAddingOvertimeRequestAlertSubscription() {
    const promises = [
      this.Admin.getUserSubordinateTeams(this.subUserInfo.id),
      this.Admin.getUserSubordinateTeamsOverwrites(this.subUserInfo.id)
    ];

    this.$q.all(promises).then(
      (success) => {
        const subordinateTeams = this.teams
          .filter(team => this.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' ? team.id !== '49a6dcff-c4e6-443e-9627-597070a68c8e' : true)
          .map(team => ({
            ...team,
            active: success[0].data.subordinateTeams.some(subordinateTeam => subordinateTeam.id === team.id),
            main: team.id === this.user.teamId,
            overwrite: success[1].data.subordinateTeamOverwrites.find(teamOverwrites => teamOverwrites.teamId === team.id)
          }))
          .sort((teamA, teamB) => teamA.name.localeCompare(teamB.name))
          .sort((teamA, teamB) => teamB.main - teamA.main);

        this.subscriptionValues = {
          language: 'en',
        };
        this.subscriptionType = 'overtimeRequestsAlert';
        this.subscriptionData = configs.overtimeRequestsAlertData;
        this.subscriptionSelect = {
          teamId: {
            valueToAdd: "id",
            valueToShow: "name",
            values: [{id: null, name: null}, ...subordinateTeams.filter(team => team.active)]
          },
        };
        this.chooseSubscription = false;
        this.addSubscriptionProcess = true;

        this.state = 'loaded';
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }
}
